(function () {
  const form = document.getElementById('withdrawal-form');
  if (!form) return;
  const i18n = window.WD_I18N || {};
  const confirmPanel = document.getElementById('withdrawal-confirm');
  const summary = document.getElementById('withdrawal-summary');
  const successPanel = document.getElementById('withdrawal-success');
  const successBody = document.getElementById('withdrawal-success-body');
  const messageEl = document.getElementById('withdrawal-message');
  const submitBtn = document.getElementById('wd-submit-btn');
  const backBtn = document.getElementById('wd-back-btn');
  const continueBtn = document.getElementById('wd-continue-btn');
  let payload = null;

  function showError(text) {
    messageEl.textContent = text;
    messageEl.hidden = false;
    messageEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  function emailValid(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  // Krok 1 → krok 2: validuj a ukaž souhrn k potvrzení
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    messageEl.hidden = true;
    const data = Object.fromEntries(new FormData(form));
    if (!data.name || !emailValid(data.email)) { showError(i18n.err_required); return; }
    payload = data;
    const rows = [
      ['name', data.name], ['email', data.email], ['orderNumber', data.orderNumber],
      ['orderDate', data.orderDate], ['deliveryDate', data.deliveryPending ? '—' : data.deliveryDate],
      ['items', data.items], ['reason', data.reason], ['iban', data.iban],
    ];
    summary.innerHTML = '';
    rows.forEach(([k, v]) => {
      if (!v) return;
      const dt = document.createElement('dt'); dt.textContent = (i18n.labels && i18n.labels[k]) || k;
      const dd = document.createElement('dd'); dd.textContent = v; // textContent = žádná injekce
      summary.appendChild(dt); summary.appendChild(dd);
    });
    form.hidden = true;
    confirmPanel.hidden = false;
    confirmPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  backBtn.addEventListener('click', function () {
    confirmPanel.hidden = true; form.hidden = false;
  });

  // Krok 2: závazné odeslání
  submitBtn.addEventListener('click', async function () {
    submitBtn.disabled = true; backBtn.disabled = true;
    try {
      if (payload.deliveryPending) payload.deliveryDate = '';
      const res = await fetch('/apps/b2b-registrace/odstoupeni', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const json = await res.json();
      if (res.ok && json.success) {
        const datum = new Date(json.createdAt).toLocaleDateString();
        confirmPanel.hidden = true;
        successBody.textContent = (i18n.success_body || '')
          .replace('{{ datum }}', datum).replace('{{ ref }}', json.ref || '');
        successPanel.hidden = false;
        successPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        showError(json.error || i18n.err_generic);
        submitBtn.disabled = false; backBtn.disabled = false;
      }
    } catch {
      showError(i18n.err_connection);
      submitBtn.disabled = false; backBtn.disabled = false;
    }
  });
})();
